import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import {useSearchStore} from 'stores/search-store';
import SearchTablePane from 'components/search/SearchTablePane.vue';
import IndexList from 'components/search/IndexList.vue';
import DiagnosisTabularList from 'components/search/DiagnosisTabularList.vue';
import IndexHeader from 'components/search/IndexHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultDetailsContent',
  setup(__props) {

const searchStore = useSearchStore();
const showIndex = computed(() => {
  return !showTable.value && searchStore.getBookCode?.endsWith('INDEX');
});

const showTabular = computed(() => {
  return searchStore.getBookCode?.endsWith('TABULAR') && !showTable.value;
});

const showTable = computed(() => {
  return searchStore.getSelectedProcedureCode && !searchStore.isTableModeSelected;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(IndexHeader, null, null, 512), [
      [_vShow, showIndex.value]
    ]),
    _withDirectives(_createVNode(IndexList, null, null, 512), [
      [_vShow, showIndex.value]
    ]),
    _withDirectives(_createVNode(DiagnosisTabularList, null, null, 512), [
      [_vShow, showTabular.value]
    ]),
    _withDirectives(_createVNode(SearchTablePane, null, null, 512), [
      [_vShow, showTable.value]
    ])
  ], 64))
}
}

})